import React from 'react'

import User, { IUser } from './user'
import Text from './text'
import ImageList, { ImageItem } from './imageList'
import Interact, { IInteract } from './interact'

export interface IWtt extends IInteract {
  user_info: IUser
  content: string
  image_list: ImageItem[]
}

interface IProps {
  info: IWtt
}

const Wtt = ({ info }: IProps) => {
  const {
    group_id,
    ugcType,
    user_info,
    content,
    image_list,
    behot_time,
    comment_count,
    digg_count,
    user_digg,
    label_tag_list,
  } = info
  return (
    <div className="ugc-wtt">
      <User info={user_info} />
      <div className="ugc-content">
        <div className="text-wrapper">
          <Text text={content} />
        </div>
        <div className="image-wrapper">
          <ImageList list={image_list} />
        </div>
        <div className="interact-wrapper">
          <Interact
            info={{
              group_id,
              ugcType,
              behot_time,
              comment_count,
              digg_count,
              user_digg,
              label_tag_list,
            }}
          />
        </div>
      </div>
      <style jsx>
        {`
          .ugc-content {
            padding-left: 60px;
          }
          .text-wrapper {
            margin-top: 11px;
          }
          .image-wrapper {
            margin-top: 8px;
          }
          .interact-wrapper {
            margin-top: 16px;
          }
        `}
      </style>
    </div>
  )
}

export default Wtt
